import { FC, useMemo } from "react";

import { EventHeader } from "Bands/components";
import { IEvent } from "Bands/types";
import { IconButton } from "shared/components";
import { ChevronLeft } from "shared/assets/icons";

import { StyledRelatedEventBanner } from "./style";
import { buildUrl } from "shared/utils";
import { BAND_PATHS } from "Bands/router";
import { getEventBandId } from "Bands/utils";

interface RelatedEventBannerProps {
  event: IEvent;
}
export const RelatedEventBanner: FC<RelatedEventBannerProps> = ({ event }) => {
  const bandId = useMemo(() => getEventBandId(event), [event]);

  return (
    <StyledRelatedEventBanner
      size="m"
      align="center"
      spaceDirection="horizontal"
    >
      <IconButton
        size="l"
        icon={ChevronLeft}
        to={buildUrl(BAND_PATHS.BAND_EVENT, {
          bandId,
          eventId: event.id,
        })}
      />
      <EventHeader event={event} />
    </StyledRelatedEventBanner>
  );
};
